/**
 * Герой: слайдер на Swiper + декоративний canvas-фон.
 *
 * Перенесено з концепту. Прив'язка до елементів — у межах секції блока
 * (.phpdev-hero), бо id тут задає редактор, а блок може бути не один.
 */

// Спільна для обох частин файлу: у концепті вона жила в зовнішньому скрипті,
// а тут слайдер і аура — окремі IIFE, і аура падала з ReferenceError.
var phpdevReduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

(function () {
  var reduce = phpdevReduceMotion;

  document.querySelectorAll('.phpdev-hero').forEach(function (root) {
    var el = root.querySelector('.viewport.swiper');
    if (!el || typeof Swiper === 'undefined') return;

    var count = root.querySelector('.slide-count');
    var total = ('0' + el.querySelectorAll('.swiper-slide').length).slice(-2);

    function setCount(sw) {
      if (count) count.textContent = ('0' + (sw.realIndex + 1)).slice(-2) + ' / ' + total;
    }

    new Swiper(el, {
      speed: reduce ? 0 : 700,
      rewind: true,                 /* з останнього слайда — назад на перший */
      grabCursor: true,
      watchSlidesProgress: true,    /* дає .swiper-slide-visible, на якому тримається правило видимості */
      autoplay: reduce ? false : { delay: 7500, disableOnInteraction: false, pauseOnMouseEnter: true },
      navigation: {
        prevEl: root.querySelector('[data-prev]'),
        nextEl: root.querySelector('[data-next]')
      },
      pagination: {
        el: root.querySelector('.dots'), clickable: true,
        bulletClass: 'dot-btn', bulletActiveClass: 'is-on',
        renderBullet: function (index, className) {
          return '<button type="button" class="' + className +
                 '" aria-label="' + (index + 1) + '"></button>';
        }
      },
      on: { init: setCount, slideChange: setCount }
    });
  });
})();

/* ---------- аура з часток ---------- */
(function(){
    var reduce = phpdevReduceMotion;
    var root = document.querySelector('.phpdev-hero');
    var cv = root && root.querySelector('canvas.aura');
    if (!cv || !cv.getContext) return;
    var ctx = cv.getContext('2d', {alpha:true});
    var cg = root.querySelector('canvas.gxy');
    var ctx2 = (cg && cg.getContext) ? cg.getContext('2d', {alpha:true}) : ctx;
    var hero = cv.parentElement, P = [], W = 0, H = 0, cx = 0, cy = 0, R = 0;
    var G = [], gx = 0, gy = 0, Rg = 0, TILT = -0.32;   /* одинока галактика */
    var SPIN0 = 5600;                 /* стартова фаза: сформована спіраль */
    var dpr = 1, raf = null, running = false, t = 0;
    var BLEED = 0;                    /* напуск світіння нижче героя */

    function measure(){
      var hr = hero.getBoundingClientRect();
      var HH = hr.height;
      /* полотно виступає нижче героя, щоб світіння заходило на наступний блок */
      BLEED = Math.round(Math.max(220, Math.min(460, HH * .42)));
      W = hr.width; H = HH + BLEED;
      dpr = Math.min(devicePixelRatio || 1, 2);
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      cv.style.width = W + 'px'; cv.style.height = H + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      if (cg){ cg.width = cv.width; cg.height = cv.height;
        cg.style.width = W + 'px'; cg.style.height = H + 'px';
        ctx2.setTransform(dpr, 0, 0, dpr, 0, 0); }

      /* центр — по фактичному положенню макета, щоб аура завжди його обіймала */
      var m = hero.querySelector('.swiper-slide-active .mock') || hero.querySelector('.mock');
      if (m){
        var mr = m.getBoundingClientRect();
        cx = mr.left - hr.left + mr.width / 2;
        cy = mr.top - hr.top + mr.height / 2;
        R  = Math.max(mr.width, mr.height) * 0.82;
      } else { cx = W * 0.72; cy = HH * 0.5; R = Math.min(W, HH) * 0.42; }
      /* галактика — над текстом, правіше центру */
      gx = W * 0.42; gy = HH * 0.108; Rg = Math.max(108, Math.min(W * 0.135, 205));

      seed(); seedGalaxy();
    }

    function seed(){
      var n = Math.max(700, Math.min(2400, Math.round(W * (H - BLEED) / 620)));
      P = [];
      for (var i = 0; i < n; i++){
        var g = (Math.random() + Math.random() + Math.random()) / 3;   /* ~нормальний розподіл */
        var out = Math.random() < .24;
        var r = out ? 1.16 + Math.pow(Math.random(), 2.2) * .9
                    : .88 + (g - .5) * .44;
        P.push({
          a: Math.random() * Math.PI * 2,
          r: r,
          sz: (out ? .7 : .95) + Math.random() * 1.35,
          sp: (out ? .00004 : .00011) + Math.random() * .00013,
          al: (out ? .16 : .34) + Math.random() * .5,
          ph: Math.random() * 6.283,
          c: Math.random() < .45 ? 1 : 0
        });
      }
    }

    function seedGalaxy(){
      var n = 780, ARMS = 2, WIND = 2.15;
      G = [];
      for (var i = 0; i < n; i++){
        var core = Math.random() < .16;
        var t = core ? Math.pow(Math.random(), 2.2) * .22       /* щільне ядро */
                     : Math.pow(Math.random(), .62);            /* рукави */
        var arm = Math.floor(Math.random() * ARMS) * (6.283 / ARMS);
        var jit = (Math.random() + Math.random() - 1) * (core ? .9 : .34 + t * .5);
        /* внутрішні крутяться швидше — диференціальне обертання */
        var w = .00042 / (.22 + t * 1.15);
        G.push({
          a: arm + t * WIND + jit + w * SPIN0,   /* старт із заданої фази */
          r: t,
          w: w,
          sz: core ? .8 + Math.random() * 1.1 : .55 + Math.random() * 1.15,
          al: (core ? .72 : .22 + (1 - t) * .5) + Math.random() * .24,
          ph: Math.random() * 6.283,
          c: core ? 2 : (Math.random() < .5 ? 1 : 0)
        });
      }
    }

    function drawGalaxy(){
      var ctx = ctx2;              /* власний шар, без маски аури */
      ctx.clearRect(0, 0, W, H);
      var ct = Math.cos(TILT), st = Math.sin(TILT);

      var core = ctx.createRadialGradient(gx, gy, 0, gx, gy, Rg * .95);
      core.addColorStop(0,   'rgba(206,226,255,.40)');
      core.addColorStop(.22, 'rgba(120,170,255,.17)');
      core.addColorStop(1,   'rgba(77,141,255,0)');
      ctx.fillStyle = core;
      ctx.fillRect(gx - Rg, gy - Rg, Rg * 2, Rg * 2);

      for (var i = 0; i < G.length; i++){
        var p = G[i];
        p.a += p.w;
        var rr = p.r * Rg;
        var lx = Math.cos(p.a) * rr;
        var ly = Math.sin(p.a) * rr * .56;      /* диск під кутом до глядача */
        var x = gx + lx * ct - ly * st;
        var y = gy + lx * st + ly * ct;
        ctx.globalAlpha = p.al * (.7 + .3 * Math.sin(t * .0021 + p.ph));
        ctx.fillStyle = p.c === 2 ? '#E4EEFF' : (p.c ? '#9CC0FF' : '#4D8DFF');
        ctx.fillRect(x, y, p.sz, p.sz);
      }
      ctx.globalAlpha = 1;
      fadeBottom(ctx);
    }

    /* низ полотна гаситься градієнтом — край не читається як лінія обрізу */
    function fadeBottom(c){
      if (!BLEED) return;
      var g = c.createLinearGradient(0, H - BLEED, 0, H);
      g.addColorStop(0, 'rgba(0,0,0,0)');
      g.addColorStop(1, 'rgba(0,0,0,1)');
      c.globalCompositeOperation = 'destination-out';
      c.fillStyle = g; c.fillRect(0, H - BLEED, W, BLEED);
      c.globalCompositeOperation = 'source-over';
    }

    function frame(){
      ctx.clearRect(0, 0, W, H);

      /* м'яке світіння під хмарою */
      var gl = ctx.createRadialGradient(cx, cy, 0, cx, cy, R * 1.75);
      gl.addColorStop(0,   'rgba(77,141,255,.20)');
      gl.addColorStop(.45, 'rgba(77,141,255,.10)');
      gl.addColorStop(1,   'rgba(77,141,255,0)');
      ctx.fillStyle = gl;
      ctx.fillRect(cx - R * 1.8, cy - R * 1.8, R * 3.6, R * 3.6);

      for (var i = 0; i < P.length; i++){
        var p = P[i];
        p.a += p.sp;
        var rr = p.r * R;
        var x = cx + Math.cos(p.a) * rr;
        var y = cy + Math.sin(p.a) * rr * .74;          /* сплюснуте кільце */
        var tw = .62 + .38 * Math.sin(t * .0016 + p.ph); /* мерехтіння */
        ctx.globalAlpha = p.al * tw;
        ctx.fillStyle = p.c ? '#9CC0FF' : '#4D8DFF';
        ctx.fillRect(x, y, p.sz, p.sz);
      }
      ctx.globalAlpha = 1;
      fadeBottom(ctx);

      drawGalaxy();
    }

    function loop(){ t += 16; frame(); raf = requestAnimationFrame(loop); }
    function start(){ if (!running){ running = true; loop(); } }
    function stop(){ running = false; if (raf) cancelAnimationFrame(raf); raf = null; }

    measure();
    if (reduce){ frame(); }
    else {
      new IntersectionObserver(function(es){
        es[0].isIntersecting ? start() : stop();
      }, {threshold:.02, rootMargin: BLEED + 'px 0px 0px 0px'}).observe(hero);
      addEventListener('visibilitychange', function(){
        document.hidden ? stop() : start();
      });
    }

    var rt = null;
    addEventListener('resize', function(){
      clearTimeout(rt);
      rt = setTimeout(function(){ measure(); if (reduce) frame(); }, 180);
    }, {passive:true});
  })();
